import { Stamp } from 'lucide-react'
import { DecorationCard } from './DecorationCard'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Card, RadioGroup } from 'src/shared/components/ui'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { Badge } from 'src/shared/components/ui/badge'

export const DecorationPicker = ({
  quoteSubItem,
  selectedPrintCode,
  setPrintCode,
  withTitle = true,
  withCard = true,
  decorations,
  readonly = false,
  fullHeight = false,
}) => {
  const { t } = useLocalization()

  const decorationName = decorations?.find(
    (d) => d?.print_code === selectedPrintCode
  )?.info?.name

  const containerClassName =
    'grid grid-cols-1 gap-2 ' +
    (fullHeight
      ? 'h-fit'
      : 'h-[197px] overflow-y-auto border border-gray-200 rounded-lg p-2 bg-white')

  const content = (
    <Column className="gap-2">
      {withTitle && (
        <Row className="items-center gap-2">
          <Stamp className="w-4 h-4" />
          <p className="text-sm">{t('Decoration', 'Dekoration')}</p>
          {!readonly && <Badge>{t(decorationName)}</Badge>}
        </Row>
      )}

      {readonly ? (
        <div className={containerClassName}>
          {decorations?.map((decoration, i) => (
            <DecorationCard
              key={i + '-decoration'}
              decoration={decoration}
              isSelected={false}
              quoteSubItem={quoteSubItem}
              readonly
            />
          ))}
        </div>
      ) : (
        <RadioGroup
          value={selectedPrintCode}
          onValueChange={(value) => setPrintCode({ print_code: value || null })}
          className={containerClassName}
        >
          {decorations?.map((decoration, i) => {
            const isSelected = selectedPrintCode === decoration.print_code

            return (
              <DecorationCard
                key={i + '-decoration'}
                decoration={decoration}
                isSelected={isSelected}
                quoteSubItem={quoteSubItem}
              />
            )
          })}
        </RadioGroup>
      )}
    </Column>
  )

  if (withCard) {
    return <Card>{content}</Card>
  }

  return content
}
